module.exports = __webpack_public_path__ + "img/gi.80dd089.webp";